function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      const dropdownElement = event.target.closest('[data-controller*="dropdown"]');
      if (dropdownElement) {
        const controller = dropdownElement.querySelector('[data-dropdown-target="menu"]');
        if (controller) {
          const dropdownController = dropdownElement.dataset.controller;
          if (dropdownController?.includes('dropdown')) {
            dropdownElement.dispatchEvent(new Event('click'));
          }
        }
      }
    }
  }
